import req from '@/utils/req.js'


//术语列表
export function termListData(params) {
    return req.post("/admin/terminology/page", params);
}
//  术语操作日志 
export function termLogListData(params) {
    return req.post("/admin/terminology-log/page", params);
}
//术语单位
export function unitListData(params) {
    return req.get("/admin/category/parentId/100500", params);
}
export function termAdd(params) {
    return req.post("/admin/terminology/add", params);
}
export function termMerge(params) {
    return req.post("/admin/terminology/clone", params);
}
export function termDetailsData(params) {
    return req.get(`/admin/terminology/${params}`);
}
export function sharePage(params) {
    return req.post("/admin/applet-share/page", params);
}
export function sharePageById(params) {
    return req.get(`/admin/applet-share/${params}`);
}
export function sharePageByIdPut(params) {
    return req.put(`/admin/applet-share`, params);
}
export function getWeChatAppList(params) {
    return req.post(`/admin/wechat-app/getWeChatAppList?type=${params}`);
}
export function outsideChainPage(params) {
    // return req.post("/dsicm-contact-platform/feign/outside-chain/page", params);
    return req.post("/dsicm-contact-platform/feign/outside-chain/page", params);
}
export function outsideChainProjectPage(params) {
    return req.post("/dsicm-contact-platform/feign/outside-chain-project/list", params);
}
export function listHospitalAllPullDown(params) {
    return req.post("/admin/hospital/listAllPullDown", params);
}
export function findIcdDiseaseList(params) {
    return req.get(`/admin/disease-type/findIcdDiseaseList?conditionName=${params}`);
}
export function saveAndCreateChain(params) {
    return req.post("/dsicm-contact-platform/feign/outside-chain/saveAndCreateChain", params);
}
export function getBelongForOutsideChain(params) {
    return req.post("/admin/platform/getBelongForOutsideChain", params);
}
export function healthToolTest(params) {
    return req.post("/admin/health-tool-test/page", params);
}
export function doctorTeamSearch(params) {
    return req.post("/admin/doctor-team/search", params);
}
export function doctorSearch(params) {
    return req.post("/admin/doctor/getDoctorListForDiseaseType", params);
}
export function getTeamServicePage(params) {
    return req.post("/admin/team-service/getTeamServicePage", params);
}
export function getChain(params) {
    return req.get(`/dsicm-contact-platform/feign/outside-chain/${params}`);
}
export function updateChain(params) {
    return req.put("/dsicm-contact-platform/feign/outside-chain", params);
}
export function downCode(params) {
    return req.get(`/dsicm-contact-platform/feign/outside-chain/outChainDownloadQrcode`,params);
}
export function saveCode(params) {
    return req.post(`/dsicm-contact-platform/feign/outside-chain/saveOutChainQrcodeUrl?id=${params.id}&imgPath=${params.imgPath}`,{});
}
export function getByIdChain(params) {
    return req.get(`/admin/landing-page/getById/${params}`);
}
export function publish(params) {
    return req.put(`/dsicm-contact-platform/feign/outside-chain/updateStatus/${params.id}`, params);
}

